import React from "react";
import StyledTooltip from "../../common/StyledTooltip";

const shimmerKeyframes = `@keyframes shimmer{0%{background-position:-600px 0}100%{background-position:600px 0}}`;
const SkeletonBox = ({ w, h, style = {} }) => (
  <div style={{
    width: w, height: h, borderRadius: "6px",
    background: "linear-gradient(90deg,#d8dff5 25%,#c8d0ed 50%,#d8dff5 75%)",
    backgroundSize: "600px 100%",
    animation: "shimmer 1.4s infinite linear",
    ...style,
  }} />
);

export default function FinancialIncomeCard({ data, loading = false }) {
  const isLarge = window.innerWidth >= 1800;
  const breakdown = [
    { label: "Principal", value: data?.financialBreakdown?.principal?.display || "₹0", originalValue: data?.financialBreakdown?.principal?.amount || 0 },
    { label: "Interest", value: data?.financialBreakdown?.interest?.display || "₹0", originalValue: data?.financialBreakdown?.interest?.amount || 0 },
    { label: "Processing Fee", value: data?.financialBreakdown?.processingFee?.display || "₹0", originalValue: data?.financialBreakdown?.processingFee?.amount || 0 },
    { label: "Charges", value: data?.financialBreakdown?.charges?.display || "₹0", originalValue: data?.financialBreakdown?.charges?.amount || 0 },
  ];
  const totalAmount =
    (data?.financialBreakdown?.principal?.amount || 0) +
    (data?.financialBreakdown?.interest?.amount || 0) +
    (data?.financialBreakdown?.processingFee?.amount || 0) +
    (data?.financialBreakdown?.charges?.amount || 0);
  const totalDisplay = `₹${(totalAmount / 100000)?.toFixed(2)}L`;

  return (
    <>
      <style>{shimmerKeyframes}</style>
      <div style={{ marginTop: "40px" }}>
        {loading ? (
          <>
            <div style={{ width: "200px", height: "22px", borderRadius: "6px", background: "linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%)", backgroundSize: "600px 100%", animation: "shimmer 1.4s infinite linear", marginBottom: "10px" }} />
            <div style={{ width: "120px", height: "14px", borderRadius: "6px", background: "linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%)", backgroundSize: "600px 100%", animation: "shimmer 1.4s infinite linear", marginBottom: "24px" }} />
          </>
        ) : (
          <>
            <h4 style={{ color: "#0A0A0A", fontWeight: "600", fontSize: "20px" }}>Financial Summary & MIS</h4>
            <p style={{ color: "#4A5565", fontSize: "14px", fontWeight: "400" }}>Month: {data?.month || "-"}</p>
          </>
        )}
      </div>

      <div style={{
        width: "100%", margin: "24px auto",
        background: loading ? "#c8cfe8" : "linear-gradient(175deg, #155DFC 0%, #9810FA 100%)",
        borderRadius: "10px", padding: "32px",
        display: "flex", flexDirection: "column", justifyContent: "space-between",
        position: "relative", overflow: "hidden",
        transition: "background 0.3s",
      }}>
        {!loading && (
          <div style={{ position: "absolute", right: "40px", top: "50%", transform: "translateY(-50%)", opacity: 0.2 }}>
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="1.5">
              <line x1="12" y1="1" x2="12" y2="23" />
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
          </div>
        )}

        <div>
          {loading ? (
            <>
              <SkeletonBox w="160px" h={isLarge ? "18px" : "14px"} style={{ marginBottom: "12px" }} />
              <SkeletonBox w="120px" h={isLarge ? "28px" : "20px"} />
            </>
          ) : (
            <>
              <h6 style={{ margin: "0px 0px 10px 0px", color: "#FFFFFF", fontSize: isLarge ? "18px" : "12px", fontWeight: "400" }}>
                Total Financial Income
              </h6>
              <StyledTooltip value={totalAmount}>
                <h6 style={{ margin: "0px 0 0 0", fontSize: isLarge ? "26px" : "16px", fontWeight: "700", color: "#ffffff", letterSpacing: "-1px" }}>
                  {totalDisplay}
                </h6>
              </StyledTooltip>
            </>
          )}
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", marginTop: "20px" }}>
          {breakdown.map((item, idx) => (
            <div key={idx}>
              {loading ? (
                <>
                  <SkeletonBox w="70px" h="13px" style={{ marginBottom: "8px" }} />
                  <SkeletonBox w="90px" h={isLarge ? "28px" : "20px"} />
                </>
              ) : (
                <>
                  <h6 style={{ margin: 0, fontSize: isLarge ? "16px" : "12px", color: "#FFFFFF", fontWeight: "400" }}>{item.label}</h6>
                  <StyledTooltip value={item.originalValue}>
                    <h6 style={{ marginTop: "6px", fontSize: isLarge ? "26px" : "16px", fontWeight: "700", color: "#ffffff", marginBottom: "0" }}>
                      {item.value}
                    </h6>
                  </StyledTooltip>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}